import General from '@/mixins/general';
import axios from "axios";

const TODO_API_URI = 'https://api.wvr-law.de/post/index.php';

export default {
    mixins: [General],
    methods: {
        createToDoVorgang(data) {
            // this.sendGaEvent();

            let _this = this;

            // Conversion-Event: Lead
            this.$gtag.event('Formular abgeschickt', {
                'event_category': this.$global.gaCat,
                'event_label': null
            });
            window.uetq = window.uetq || [];
            window.uetq.push('event', 'Formular abgeschickt', {'event_category': this.$global.gaCat});
            window.fbq('track', 'Lead');

            // Conversion-Event: Qualifizierter Lead
            let qualiArray = ["Barzahlung","Voll bezahlt","Darlehen","Finanzierung"];
            if( data.rsv_bei_kauf_vorhanden === "Ja" && qualiArray.includes(data.finanzierungsart) && data.automarke !== "Sonstiges" ) {
                this.$gtag.event('Qualifizierter Lead', { 'event_category': _this.$global.gaCat, 'event_label': null, 'value' : 740 });
                window.uetq.push('event', 'Qualifizierter Lead', {'event_category': this.$global.gaCat, 'event_value': 740});
                window.fbq('track', 'Qualifizierter Lead');
            }
            // Conversion-Event: Qualifizierter Lead (Mercedes)
			/*
            else if( data.rsv_bei_kauf_vorhanden !== "Ja" && qualiArray.includes(data.finanzierungsart) && data.automarke === "Mercedes-Benz" ) {
                this.$gtag.event('Qualifizierter Lead', { 'event_category': _this.$global.gaCat, 'event_label': null, 'value' : 200 });
                window.uetq.push('event', 'Qualifizierter Lead', {'event_category': this.$global.gaCat, 'event_value': 200});
            }
			*/

            // Google Get-Parameter
            if(this.$route.query.source) { data.ad_source = this.$route.query.source; }
            if(this.$route.query.campaignid) { data.ad_campaignid = this.$route.query.campaignid; }
            if(this.$route.query.adgroupid) { data.ad_adgroupid = this.$route.query.adgroupid; }
            if(this.$route.query.gclid) { data.gclid = this.$route.query.gclid; }

            let s = new URLSearchParams(this.clearObjectforSerialize(data)).toString();
            if (process.env.VUE_APP_ENV === "prod") {
                axios.post(
                    TODO_API_URI,
                    s
                ).then(response => {
                    return response.status != 200
                }).catch(err => {
                    console.log(err);
                    return true;
                });
            } else {
                console.log('Kein Submit: an '+TODO_API_URI+" mit "+s);
                return true;
            }
        },
    },
};
